import React, { useState, useEffect } from 'react';

import { includes, isEmpty } from 'lodash';
import { PURGE } from 'redux-persist';
import { useInterval } from 'react-use';
import { useLocation } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { useDispatch, useSelector } from 'react-redux';

import { authRoutes, unAuthRoutes } from '../routes';
import ALWAYS_UNAUTH from '@constants/ALWAYS_UNAUTH';
import { selectSession } from '@state/selectors';
import { authenticate } from '@state/actions';
import { Maintenance } from '@components';
import { Statuses } from '@services/http';
import { getToken } from '@utils/storage';

const Views = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let session = useSelector(selectSession);
  const [onMaintenance, setOnMaintenance] = useState(false);
  const token = getToken();

  if (!session || !session.loggedIn || !token) {
    dispatch({
      type: PURGE,
      key: 'root',
      result: () => null,
    });
  }

  const onCheckStatus = async () => {
    try {
      await Statuses.status();
      setOnMaintenance(false);
    } catch (err) {
      setOnMaintenance(true);
    }
  };

  useInterval(() => {
    onCheckStatus();
  }, 60000);

  useEffect(() => {
    onCheckStatus();
  });

  useEffect(() => {
    const token = getToken();
    if (!session.loggedIn && token) {
      dispatch(authenticate);
    }
  }, [dispatch, session.loggedIn]);

  if (onMaintenance) {
    return <Maintenance />;
  }

  return session.loggedIn &&
    !isEmpty(session.user) &&
    !includes(ALWAYS_UNAUTH, location.pathname)
    ? renderRoutes(authRoutes(session.user.roles)(session.user.permissions))
    : renderRoutes(unAuthRoutes()());
};

export default Views;
